import {useEffect, useRef, useState} from 'react'
import './ProductAlertTagsSelector.css'

// Alerta tag do food img

export type ProductAlertTagType = {
  id: number
  name: string
  img: string
  checked: boolean
}

type ProductAlertTagsSelectorProps = {
  tags: ProductAlertTagType[]
  onChange: (tags: ProductAlertTagType[]) => void
  onInteraction?: () => void
}

function resolveTagImage(img: string) {
  if (!img) return ''
  if (img.startsWith('http')) return img
  if (process.env.REACT_APP_AWS_S3_URL) {
    return `${process.env.REACT_APP_AWS_S3_URL}/${img}`
  }
  return img
}

export function ProductAlertTagsSelector({
  tags,
  onChange,
  onInteraction,
}: ProductAlertTagsSelectorProps) {
  const [isOpen, setIsOpen] = useState(false)
  const hasInitialized = useRef(false)
  const selectedCount = tags.filter((tag) => tag.checked).length

  useEffect(() => {
    if (!hasInitialized.current && tags.length > 0) {
      hasInitialized.current = true
      if (selectedCount > 0) {
        setIsOpen(true)
      }
    }
  }, [tags, selectedCount])

  const toggleTag = (id: number) => {
    onInteraction?.()
    onChange(tags.map((item) => (item.id === id ? {...item, checked: !item.checked} : item)))
  }

  const selectedLabel =
    selectedCount === 0
      ? 'Nenhum selecionado'
      : selectedCount === 1
      ? '1 selecionado'
      : `${selectedCount} selecionados`

  return (
    <div className='product-alert-tags-section mt-8'>
      <div className='accordion accordion-icon-toggle product-alert-tags-accordion'>
        <div className='accordion-item border border-gray-300 rounded'>
          <h2 className='accordion-header'>
            <button
              type='button'
              className={`accordion-button py-4 ${isOpen ? '' : 'collapsed'}`}
              onClick={() => setIsOpen((current) => !current)}
              aria-expanded={isOpen}
            >
              <div className='d-flex align-items-center justify-content-between w-100 me-3'>
                <div className='d-flex align-items-center'>
                  <i className='fas fa-exclamation-circle text-warning fs-3 me-3'></i>
                  <div className='d-flex flex-column align-items-start'>
                    <span className='fw-bold fs-6 text-dark'>Alertas alimentares</span>
                    <span className='text-muted fs-7 mt-1'>
                      Selecione os ícones de alérgenos do produto
                    </span>
                  </div>
                </div>
                <span
                  className={`badge ${
                    selectedCount > 0 ? 'badge-light-success' : 'badge-light-secondary'
                  }`}
                >
                  {selectedLabel}
                </span>
              </div>
            </button>
          </h2>
          <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
            <div className='accordion-body pt-2 pb-6 px-4'>
              {tags.length === 0 ? (
                <div className='text-muted text-center py-6'>Nenhuma tag de alerta cadastrada.</div>
              ) : (
                <div className='product-alert-tags-grid'>
                  {tags.map((tag) => (
                    <button
                      key={tag.id}
                      type='button'
                      className={`product-alert-tag-option ${
                        tag.checked ? 'product-alert-tag-option-selected' : ''
                      }`}
                      onClick={() => toggleTag(tag.id)}
                      title={tag.name}
                    >
                      <img src={resolveTagImage(tag.img)} alt={tag.name} />
                      <span>{tag.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
